import { twMerge } from "tailwind-merge";
import { Typography } from "@pondigitalsolutions/pon-component-library";

const STATUS_VARIANTS = {
  success: "bg-accent_two-500 border-accent_two-500 dark:bg-transparent ",
  error: "bg-accent_three-700 border-accent_three-700 dark:bg-transparent",
  warning: "bg-accent_one-600 border-accent_one-600 dark:bg-transparent",
  info: "bg-primary-500 border-primary-500 dark:bg-transparent",
  soft: "bg-white/10 border-transparent",
  default:
    "bg-white border-tertiary-50  dark:bg-white/10 dark:border-white/10 ",
};

const STATUS_VARIANTS_TEXT = {
  success: "text-accent_two-50 dark:text-accent_two-300",
  error: "text-accent_one-50 text-accent_three-50 dark:text-accent_three-100",
  warning: "text-accent_one-50 dark:text-accent_one-100",
  info: "text-secondary-700 dark:text-secondary-100",
  soft: "text-white",
  default: "text-secondary-800 dark:text-white",
};

interface LabelProps {
  children: React.ReactNode;
  variant?: keyof typeof STATUS_VARIANTS;
  className?: string;
}

export const Label = ({
  variant = "default",
  children,
  className,
}: LabelProps) => {
  const labelClasses = twMerge(
    "flex items-center justify-center rounded-sm border px-3 py-2 gap-1",
    STATUS_VARIANTS[variant],
    className
  );
  const textClasses = twMerge(
    "text-center leading-none font-normal",
    STATUS_VARIANTS_TEXT[variant]
  );

  return (
    <div className={labelClasses}>
      <Typography size="xs" className={textClasses}>
        {children}
      </Typography>
    </div>
  );
};
